import { useForm } from '@inertiajs/react';

export default function AccountActivationPage({ activation }) {
    const isReadOnly = !!activation;
    const { data, setData, post, processing, wasSuccessful, errors } = useForm({
        usage: activation?.request?.usage || '',
        location: activation?.request?.location || '',
        institution: activation?.request?.institution || ''
    });

    const handleChange = (e) => {
        if (isReadOnly) return;
        setData(e.target.name, e.target.value);
    };

    const handleSubmit = (e) => {
        e.preventDefault();
        if (isReadOnly) return;
        post('/account/activation/request');
    };

    return (
        <div className="flex flex-col items-center justify-center flex-grow bg-gray-50">
            <h1 className="text-1xl font-thin font-semibold text-gray-900 sm:text-2xl lg:text-3xl">
                Account Activation Request
            </h1>

            <div className="mt-8 w-full max-w-md shadow-sm">
                {wasSuccessful && (
                    <div className="bg-green-100 border-l-4 border-green-400 text-green-700 p-4 rounded-md mb-6 shadow-sm">
                        <p>
                            Your activation request has been submitted successfully!
                        </p>
                    </div>
                )}
                {errors.activation && (
                    <div className="bg-red-100 border-l-4 border-red-400 text-red-700 p-4 rounded-md mb-6 shadow-sm">                       
                        <p>{errors.activation}</p>
                    </div>
                )}

                {activation?.state == 'requested' && (
                    <div className="bg-yellow-100 border-l-4 border-yellow-400 text-yellow-700 p-4 rounded-md mb-6 shadow-sm">
                        <p>
                            Your account activation request is under review. Please wait for further updates.
                        </p>
                    </div>
                )}
                {activation?.state == 'declined' && (
                    <div className="bg-red-100 border-l-4 border-red-400 text-red-700 p-4 rounded-md mb-6 shadow-sm">
                        <p>
                            Your account activation request has been declined. Please contact support for more information.
                        </p>
                    </div>
                )}
                {activation?.state == 'accepted' && (
                    <div className="bg-green-100 border-l-4 border-green-400 text-green-700 p-4 rounded-md mb-6 shadow-sm">
                        <p>
                            Your account has been activated, you can now start using the platform.
                        </p>
                    </div>
                )}
                {activation?.state == 'suspended' && (
                    <div className="bg-red-100 border-l-4 border-red-400 text-red-700 p-4 rounded-md mb-6 shadow-sm">
                        <p>
                            Your account has been <strong>suspended</strong>.
                        </p>
                    </div>
                )}

                <form
                    className="border border-gray-200 bg-white rounded-lg px-6 py-6"
                    onSubmit={handleSubmit}
                >
                    <div className="mb-5">
                        <label className="block text-gray-800 text-base font-medium mb-2" htmlFor="usage">
                            Intended Usage
                        </label>
                        <textarea
                            id="usage"
                            name="usage"
                            value={data.usage}
                            onChange={handleChange}
                            className="border border-gray-300 rounded-md w-full py-2 px-3 text-gray-900 focus:outline-none focus:ring-2 focus:ring-blue-400 transition"
                            placeholder="Describe how you intend to use the platform"
                            required
                            rows={3}
                            readOnly={isReadOnly}
                        />
                        {errors.usage && <div className="text-red-500 text-sm mt-1">{errors.usage}</div>}
                    </div>
                    <div className="mb-5">
                        <label className="block text-gray-800 text-base font-medium mb-2" htmlFor="location">
                            Location / Country
                        </label>
                        <input
                            id="location"
                            name="location"
                            type="text"
                            value={data.location}
                            onChange={handleChange}
                            className="border border-gray-300 rounded-md w-full py-2 px-3 text-gray-900 focus:outline-none focus:ring-2 focus:ring-blue-400 transition"
                            placeholder="Your location or country"
                            required
                            readOnly={isReadOnly}
                        />
                        {errors.location && <div className="text-red-500 text-sm mt-1">{errors.location}</div>}
                    </div>
                    <div className="mb-6">
                        <label className="block text-gray-800 text-base font-medium mb-2" htmlFor="institution">
                            Research Institution (if available)
                        </label>
                        <input
                            id="institution"
                            name="institution"
                            type="text"
                            value={data.institution}
                            onChange={handleChange}
                            className="border border-gray-300 rounded-md w-full py-2 px-3 text-gray-900 focus:outline-none focus:ring-2 focus:ring-blue-400 transition"
                            placeholder="Your research institution"
                            readOnly={isReadOnly}
                        />
                        {errors.institution && <div className="text-red-500 text-sm mt-1">{errors.institution}</div>}
                    </div>
                    {!isReadOnly && (
                        <button
                            type="submit"
                            className="w-full bg-slate-600 hover:bg-slate-700 text-white font-semibold py-2 rounded-md transition focus:outline-none focus:ring-2 focus:ring-blue-400"
                            disabled={processing}
                        >
                            {processing ? 'Submitting...' : 'Request Activation'}
                        </button>
                    )}
                </form>
            </div>
        </div>
    ); 
}
